import PropTypes from 'prop-types'
import React, { Component } from "react"
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { find } from 'lodash'
import keyMirror from 'keymirror'
import classNames from 'classnames'
import UISelect from 'components/shared/UISelect'
import TargetConditionEditModal from './TargetConditionEditModal'
import EditableAreaStyles from 'components/CampaignWizards/MessageUsers/Compose/EditableArea/style'

import { fetchTargets } from 'app/modules/targeting/actions'
import { byId, lastCreatedTargetId } from 'app/modules/targeting/selectors'
import { org } from 'app/modules/org/selectors'

import style from './style'

const ALWAYS_OPTION_ID = -1
const defaultToAlwaysOptionId = (optionId) => optionId || ALWAYS_OPTION_ID
const defaultTargetOption = { label: 'Always', value: ALWAYS_OPTION_ID }
const targetToOption = ({ name, id }) => ({ label: name, value: id })

const ModalState = new keyMirror({
  HIDDEN: null,
  CREATE: null,
  EDIT: null,
})

class TargetConditionInput extends Component {
  static propTypes = {
    /*
     * This function should have the signature (value, edited) => ()
     * `value` is the target selected
     * `edited` is whether that target has been modified
     *
     * This allows notifying the parent component whether the campaign needs
     * to be republished due to changes to the targeting conditions
     */
    onSelection: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      plainTargets: props.plainTargets,
      modalState: ModalState.HIDDEN
    }
  }

  componentDidMount() {
    this.props.actions.fetchTargets()
  }

  componentWillReceiveProps(nextProps) {
    const justCreatedTargetId = nextProps.lastCreatedTargetId
    if (this.props.lastCreatedTargetId != justCreatedTargetId) {
      this.handleSelection({ value: justCreatedTargetId })
    }

    if (this.props.plainTargets !== nextProps.plainTargets) {
      this.setState({
        plainTargets: nextProps.plainTargets
      })
    }
  }

  resolveTargetOptions() {
    const { plainTargets } = this.state
    const { filterPlaybookTargets } = this.props
    const options = _.map(plainTargets, targetToOption)
    if (filterPlaybookTargets) {
      const filteredOptions = options
        .filter(option => !!option.label && !(option.label.startsWith('playbook-') || option.label.startsWith('leadbot-playbook-')))
      return [defaultTargetOption, ...filteredOptions]
    } else {
      return [defaultTargetOption, ...options]
    }
  }

  handleSaveTargetCondition = (value) => {
    this.props.onSelection(value, true)
    this.props.actions.fetchTargets()
  }

  handleSelection = (option) => {
    this.props.onSelection(option.value, false)
  }

  setModalState = (modalState) => () => {
    this.setState({ modalState })
  }

  renderSelectOption = ({ label }) => (
    <span className="targeting-dropdown-option">
      {label}
    </span>
  )

  render() {
    const { selectedTargetId, className, style } = this.props
    const targetOptions = this.resolveTargetOptions()

    const selectOptions = {
      multi: false,
      autoFocus: true,
      search: true,
      options: targetOptions,
      pageSize: 6,
      optionRenderer: this.renderSelectOption,
      onChange: this.handleSelection,
      value: defaultToAlwaysOptionId(selectedTargetId)
    }

    return (
      <div
        key="targetCondition"
        className={classNames(EditableAreaStyles.InputWrapper, className)}
        style={style}>

        <div className="flex-space-between">
          <label className="dsg-Label color-navy-dark">display when</label>
          { this.renderActionLinks() }
        </div>

        <div className="targeting-dropdown">
          <UISelect {...selectOptions} />
        </div>

        { this.renderModal() }
      </div>
    )
  }

  renderActionLinks() {
    const { selectedTargetId } = this.props
    let editLink

    if (!!selectedTargetId) {
      editLink = [
        <div style={{ margin: "0 0.5rem" }}> | </div>,
        <div
            onClick={ this.setModalState(ModalState.EDIT) }
            className="link dsg-Regular"
        >
          Edit
        </div>
      ]
    }

    return (
      <div className="flex" style={{ alignItems: "center" }}>
        <div
          onClick={ this.setModalState(ModalState.CREATE) }
          className="link dsg-Regular">
          Create New
        </div>
        { editLink }
      </div>
    )
  }

  renderModal() {
    const { org, plainTargets } = this.props
    const { modalState } = this.state
    if (modalState === ModalState.HIDDEN) return
    const editTarget = modalState === ModalState.EDIT ? find(plainTargets, (target) => target.id === this.props.selectedTargetId) : undefined

    return (
      <TargetConditionEditModal
        org={org}
        targets={plainTargets}
        onSave={this.handleSaveTargetCondition}
        onClose={this.setModalState(ModalState.HIDDEN)}
        editTarget={editTarget}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchTargets,
    },
    dispatch
  ),
})


const mapStateToProps = state => ({
  plainTargets: byId(state).toJS(),
  lastCreatedTargetId: lastCreatedTargetId(state),
  org: org(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(TargetConditionInput)



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/index.js